import { IEmployeeIntegration, IntegrationType, ISiteIntegration } from 'types';
import { toTitleCase } from './strings';

export const formatIntegrationName = (integration: ISiteIntegration | IEmployeeIntegration): string => {
  switch (integration.type) {
    case IntegrationType.ADP_RUN_EXPORT:
      return 'ADP Run';
    case IntegrationType.PAYLOCITY_EXPORT:
      return 'Paylocity';
    case IntegrationType.RESTAURANT365_EXPORT:
      return 'Restaurant365';
    case IntegrationType.HEARTLAND:
      return 'Genius';
    default:
      return toTitleCase(integration.type.split('_').join(' '));
  }
};
